import { Component } from '@angular/core';

import { SectionService } from '../../services/section.service';
import { NX23FooterFields } from '../../types/content-types';
import { Observable, map } from 'rxjs';
import { FaqsService } from 'src/app/core/services/faqs-service/faqs.service';

@Component({
  selector: 'nx-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  providers: [SectionService],
})
export class FooterComponent {
  public data$: Observable<NX23FooterFields> = this.faqsService
    .getFooter()
    .pipe(map(data => data.fields));

  constructor(section: SectionService, private faqsService: FaqsService) {
    section.sectionName = 'footer';
  }
}
